import Framework from 'framework';
import _ from 'ext:lodash';
import SessionStorage from 'lib/session-storage';

export default function formTracking() {
	var formEl = jQuery('form#leadForm, form#contactUs');
	if(formEl.length > 0) {
		var formType = 'Expanded';
		var formName = $("meta[property='og:title']").attr('content'),
        formLeadType = jQuery(formEl).find("input[name='ltf_inquirytype']").val();
		Framework.actions.collectAnalytics({
            form: {
                formType: formType,
                formName: formName,
                formLeadType: formLeadType
            },
            event: 'Form Viewed'
        });
		var s = jQuery(formEl).find('input,select');
		jQuery(formEl).find('input,select').on('change', function() {
			var position = s.index(this) + 1,
				fieldName = jQuery(this).attr('name');
			Framework.actions.collectAnalytics({
				form: {
					formType: formType,
					formName: formName,
					formLeadType: formLeadType,
					formField: {
						formSection: $("label[for='" + $(this).attr('id') + "']").text(),
						fieldName: fieldName,
						fieldPosition: position
					}
				},
				event: 'Form Started'
			});
		});
		jQuery(formEl).parsley().on('form:submit', function () {
			SessionStorage.set('form-succeeded', {
				form: {
					formType: formType,
					formName: formName,
					formLeadType: formLeadType
				},
				event: 'Form Submission Succeeded'
			});
		});
		jQuery(formEl).parsley().on('form:error', function() {
			var errCount = 0;
			this.fields.forEach(function(formId) {
				if(formId.validationResult.length && formId.validationResult.length > 0) {
					errCount++;
				}
			});
			if(errCount > 0) {
				Framework.actions.collectAnalytics({
					form: {
						formType: formType,
						formName: formName,
						formLeadType: formLeadType,
						formError: errCount + ' field validation errors'
					},
					event: 'Form Submission Failed'
				});
			}
		});
	}
}
